import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { SpecialInsuranceCoverage } from "Store/interfaces/products/coverage";

export const getTermCoverages = (
  productBackendName: ProductBackendName,
): SpecialInsuranceCoverage[] | undefined => {
  if (productBackendName === ProductBackendName.AKA_STUDENT) {
    return [
      SpecialInsuranceCoverage.AKA_STUDENT_TRAVEL,
      SpecialInsuranceCoverage.AKA_STUDENT_HOUSE_CONTENTS,
    ];
  }

  return undefined;
};
